app.controller("StudentRegistrationIndexController", [
    "$scope", "StSubject", "StaticData", "Students", "ProgramService", "$uibModal", "$stateParams", "$state", "usSpinnerService", "ConfirmModal", "toastr",
    function ($scope, StSubject, StaticData, Students, ProgramService, $uibModal, $stateParams, $state, usSpinnerService, ConfirmModal, toastr) {
        $scope.students = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.statesMap = {};
        $scope.levelsMap = {};
        $scope.query = $stateParams.query;
        $scope.level = $stateParams.level;
        $scope.state = 'candidate';
        $scope.faculty = $stateParams.faculty;
        $scope.semester = $stateParams.semester || 'სემესტრი';
        $scope.sortType = $stateParams.sortType || 'by_name';
        $scope.semesters = ['სემესტრი'].concat(_.range(1, 15));

        if ($stateParams.program) {
            ProgramService.fetchOne($stateParams.program).then(function (program) {
                $scope.program = program;
            });
        }

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                faculty: $scope.faculty,
                level: $scope.level,
                sortType: $scope.sortType,
                program: $scope.program ? $scope.program._id : undefined,
                semester: $scope.semester !== 'სემესტრი' ? $scope.semester : undefined
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            Students.list({
                page: page,
                limit: $scope.itemsPerPage,
                query: $stateParams.query,
                faculty: $stateParams.faculty,
                level: $stateParams.level,
                state: $scope.state,
                sortType: $scope.sortType,
                program: $stateParams.program,
                semester: $stateParams.semester
            }).then(function (data) {
                var studentList = data.docs;
                for (var i in studentList) {
                    if (!studentList[i].user.photo && studentList[i].user.gender === 'male') studentList[i].user.defaultPhoto = "img/male.jpg";
                    if (!studentList[i].user.photo && studentList[i].user.gender === 'female') studentList[i].user.defaultPhoto = "img/female.jpg";
                    else if (!studentList[i].user.photo && !studentList[i].user.gender) studentList[i].user.defaultPhoto = "img/no_image.jpg";
                }
                $scope.students = studentList;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.send = function () {
            Students.sendNotification().then(function (data) {
                console.log('data', data)
            })
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "AddStudentController",
                templateUrl: _pb + 'admin/students/add-student.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.finances = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go("admin.studentPayments", {studentId: student._id, student: student});
        };

        $scope.edit = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditStudentController",
                templateUrl: _pb + 'admin/students/edit-student.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    student: function () {
                        return student;
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($scope.currentPage);
                }, function () {
                });
        };

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };

        $scope.showDetails = function (student) {
            $state.go("admin.student-registration-register", {studentId: student._id});
        }

        $scope.deleteAll = function () {
            ConfirmModal.show({
                title: "ნამდვილად გსურთ ყველა კანდიდატის წაშლა?",
                message: "დადასტურების შემთხვევაში წაიშლება ყველა ჩანაწერი!!!"
            }).result.then(function () {
                Students.deleteCandidates().then(function () {
                    $scope.currentPage = 1;
                    loadPage(1);
                    toastr.success('', 'ყველა კანდიდატი წაშლილია');
                })
            });
        }
    }
]);
